/* eslint-disable no-func-assign */
import { FC } from "react";
import styles from "./InspirationsList.module.css";
import Card from "../Card/Card";
import useWindowSize from "../../hooks/useWindowSize";
import { cardWidth } from "../../utils/layoutUtils";
import { InspirationDb } from "../../models/inspiration.db";
import { aspectRation } from "../../constants";

interface Props {
  inspirations: Array<InspirationDb>;
  onShowModal: () => void;
  emptyString: string;
}
const InspirationsList: FC<Props> = ({
  inspirations,
  onShowModal,
  emptyString,
}) => {
  const windowSize = useWindowSize();
  const width = cardWidth(windowSize.width);
  return (
    <div className={styles.listCards}>
      {inspirations.length ? (
        inspirations.map((insp) => {
          return (
            <div
              key={insp.id}
              onClick={() => {
                onShowModal();
              }}
              style={{
                backgroundImage: `url(${insp.picUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: width,
                height: width * aspectRation,
              }}
            />
          );
        })
      ) : (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {emptyString}
        </div>
      )}
    </div>
  );
};
export default InspirationsList;
